<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" style="margin: 0" label-suffix="：" size="medium">
          <el-form-item label="SKU名称">
            <el-input minlength="2" v-model="searchForm.PRODUCT_NAME" clearable @keyup.enter.native="filtrate"></el-input>
          </el-form-item>
          <el-form-item label="SKU编码">
            <el-input minlength="2" v-model="searchForm.PRODUCT_CODE" clearable @keyup.enter.native="filtrate"></el-input>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions1" value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="filtrate">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <tooltip-button button-type="primary" button-plain :disabled="isExportPosible" buttonText="导出" :tipContent="exportTip"
              @click="exportTable">
            </tooltip-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" border stripe show-summary :summary-method="getSummaries">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
        <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
        <el-table-column prop="PROJECT_NAME" label="门店名称"></el-table-column>
        <el-table-column prop="DK_NAME" label="档口名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="REAL_PRICE" label="价格"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
        <el-table-column prop="PRODUCT_GYS_FEE" label="订单总金额"></el-table-column>
        <el-table-column prop="REAL_GYS_FEE" label="实收总金额"></el-table-column>
        <el-table-column label="操作" width="65" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalCount" style="float: right">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import { searchSellFun, exportSellFun } from '@/assets/api/sellOrder';
import { frontEndFun } from '@/assets/api/frontFun';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';
import { 判断日期范围是否超过限制 } from '@/assets/common/date';

export default {
  data() {
    return {
      PAGE_ID: '10203',
      searchForm: {},
      customerLists: [],
      tableData: [],
      pickerOptions1: {},
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      totalCountObj: {},
    };
  },
  created() {
    this.queryBeforeFun();
    if (this.SERACH_SELL_ORDER_DATA_CONDITION.CONDITION) {
      this.searchForm = this.SERACH_SELL_ORDER_DATA_CONDITION.CONDITION;
      this.tableData = this.SERACH_SELL_ORDER_DATA_CONDITION.DATA;
      this.totalCount = this.SERACH_SELL_ORDER_DATA_CONDITION.TOTAL_COUNT;
      this.currentPage = this.SERACH_SELL_ORDER_DATA_CONDITION.CURRENT_PAGE;
    }
  },
  computed: {
    SERACH_SELL_ORDER_DATA_CONDITION() {
      return this.$store.state.SERACH_SELL_ORDER_DATA_CONDITION;
    },
    isExportPosible() {
      return this.isDateRangeSelected && !this.isDateRangeOverLimit;
    },
    isDateRangeSelected() {
      return this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length;
    },
    isDateRangeOverLimit() {
      return 判断日期范围是否超过限制(...this.searchForm.DAY_INTERVAL, 92);
    },
    exportTip() {
      return !this.isDateRangeSelected ? '请选择日期范围' : this.isDateRangeOverLimit ? '日期范围不能超过3个月' : '';
    },
  },
  methods: {
    // 单元格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'PRODUCT_COUNT' || column.property === 'REAL_COUNT' || column.property === 'PRODUCT_GYS_FEE' || column.property === 'REAL_GYS_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2); // 保留2位小数，解决小数合计列
        }
      });
      this.sums = sums;
      return sums;
    },
    detail(row) {
      sessionStorage.setItem('SEARCH_ORDER_ID', row.ORDER_ID);
      this.$router.push({ path: 'searchSellOrderDetail/detail' });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    filtrate() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      if (!(this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (判断日期范围是否超过限制(...this.searchForm.DAY_INTERVAL, 365)) {
        this.$message.show({ text: '日期范围请不要超过一年', type: 'warning' });
        return false;
      }
      if (!validation.产品编码验证(this.searchForm.PRODUCT_CODE)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      if (!this.searchForm.PRODUCT_CODE && !this.searchForm.PRODUCT_NAME) {
        this.$message.show({ text: 'SKU名称和SKU编码必须输入一项', type: 'warning' });
        return false;
      }

      const params = {
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
        NEED_COUNT: Number(!(JSON.stringify(this.searchForm) in this.totalCountObj)),
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }

      searchSellFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].PRODUCT_INFO.map((item) => Object.assign(item, {
            PRODUCT_CODE: item.PRODUCT_CODE.toString(),
          }));
          if (result[0].TOTAL_COUNT) {
            this.totalCount = result[0].TOTAL_COUNT;
            if (!(JSON.stringify(this.searchForm) in this.totalCountObj)) this.totalCountObj[JSON.stringify(this.searchForm)] = this.totalCount;
          } else this.totalCount = this.totalCountObj[JSON.stringify(this.searchForm)];
          this.$store.dispatch('SET_SERACH_SELL_ORDER_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            CURRENT_PAGE: this.currentPage,
            TOTAL_COUNT: this.totalCount,
          });
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.totalCount = 0;
        this.tableData = [];
      });
    },
    exportTable() {
      const params = {};
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      exportSellFun(params).then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.tableData = [];
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/searchSellOrder.vue